import CheckDepositHistoryScreen from 'features/rdc/screens/CheckDepositHistory/CheckDepositHistoryScreen';
import React from 'react';

export default function Page() {
  return <CheckDepositHistoryScreen />;
}
